/**************************************************
 * Nombre:       CatalogoLista
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabs_Sub_Categorias from "./Tabs_Sub_Categorias";
import {useEffect, useState} from "react";
import ListaProductos from "./ListaProductos";
import useRecuperarColleccionListeningProg from "../../../../Servicios/BD/useRecuperarColleccionListeningProg";
import {where} from "firebase/firestore";

const CatalogoLista = () => {
    const [escogido, setEscogido] = useState('');
    const [wheres, setWheres] = useState([]);
    const {data, cargarMas} = useRecuperarColleccionListeningProg({
        col: 'productos',
        limit: 10,
        orden: 'prioridad',
        wheres: wheres,
        direccion: 'asc'
    });


    useEffect(() => {

        if (escogido === 'Todos') {
            setWheres([])
        } else {
            let w = [where('categoria', '==', escogido)]
            setWheres(w)
        }

    }, [escogido]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 0}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Tabs_Sub_Categorias escogido={escogido} setEscogido={setEscogido}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8, px: 6}}>
                    <ListaProductos items={data} cargaMas={cargarMas}/>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default CatalogoLista